import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeader } from './ui/SectionHeader';
import { XIcon } from 'lucide-react';
export function WhyFailed() {
  const failures = [{
    title: 'Language Apps',
    desc: 'teach you how to pass a school test, but they ignore the high-stakes etiquette required in a real Italian business or social setting.'
  }, {
    title: 'Generic Phrasebooks',
    desc: "give you 1,000 words you'll never use and zero context on the 50 words that actually grant you access."
  }, {
    title: 'The "Customer is King" Mindset',
    desc: 'is an American concept that fails in Italy; here, the "Guest" is king, and entry is earned through specific rituals of respect.'
  }];
  return <section className="py-24 bg-ivory-100" data-id="element-192">
      <div className="max-w-4xl mx-auto px-6" data-id="element-193">
        <SectionHeader eyebrow="Why What You Tried Didn't Work" title="The Flawed Approach" data-id="element-194" />

        <div className="mt-12 space-y-8" data-id="element-195">
          {failures.map((item, index) => <FadeIn key={index} delay={0.1 * (index + 1)} direction="left" data-id="element-196">
              <div className="flex items-start gap-6 group" data-id="element-197">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-900/5 flex items-center justify-center border border-red-900/10 group-hover:bg-red-900/10 transition-colors" data-id="element-198">
                  <XIcon className="w-5 h-5 text-red-800/70" strokeWidth={1.5} data-id="element-199" />
                </div>
                <div data-id="element-200">
                  <h3 className="text-xl font-serif text-emerald-900 mb-2" data-id="element-201">
                    {item.title}
                  </h3>
                  <p className="text-charcoal/70 font-sans font-light leading-relaxed" data-id="element-202">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}